<template>
<div>

</div>
</template>

<script>
export default {
    name: "PatientEdit"
}
</script>

<style scoped>

</style>